import Variant from './variant';
import traits from './traits';

const OPERATING_SYSTEM_ORDER = [
  traits.operatingSystem.windows.uuid,
  traits.operatingSystem.osx.uuid,
  traits.operatingSystem.linux.uuid,
];

class DigitalListing {
  constructor(json) {
    this.json = json;
    $.extend(this, json); // copy all fields to this object
  }

  get variants() {
    return this.unorderedVariants.sort((variant1, variant2) => {
      const index1 = OPERATING_SYSTEM_ORDER.indexOf(variant1.operatingSystem.value_uuid);
      const index2 = OPERATING_SYSTEM_ORDER.indexOf(variant2.operatingSystem.value_uuid);
      return index1 - index2;
    });
  }

  get unorderedVariants() {
    return this.json.variants.map(variantJson =>
      new Variant(variantJson));
  }

  get free() {
    return this.price.amount_cents === 0;
  }
}

export default DigitalListing;



// WEBPACK FOOTER //
// ./javascripts/components/digital_listings/digital_listing.js